import { useCallback } from 'react';

import useMediaLibrarySearchQuery from '~modules/media-library/context/useMediaLibrarySearchQuery';
import useMediaLibrarySettings from '~modules/media-library/context/useMediaLibrarySettings';
import useMediaLibraryUserPreferences from '~modules/media-library/context/useMediaLibraryUserPreferences';
import { DEFAULT_SORT_KEY } from '~modules/media-library/model/SortOption';
import { SortOrder } from '~modules/media-library/model/SortOrder';
import { FilterBar } from '~modules/media-library/view/FilterBar/FilterBar';
import { Header } from '~modules/media-library/view/Header/Header';
import { SearchBar } from '~modules/media-library/view/SearchBar/SearchBar';
import { TabFilterBar } from '~modules/media-library/view/TabFilterBar/TabFilterBar';
import { TagBar } from '~modules/media-library/view/TagBar/TagBar';

export default function SearchHeaderController() {
  const { filterList, tabFilter } = useMediaLibrarySettings();
  const {
    activeFilterIds,
    preferredSortKey,
    onSort,
    selectedFilterValueIds,
    selectedTabFilterId,
    onSetActiveFilterIds,
    onSetSelectedFilterValueIds,
    onSetSelectedTabFilterId,
  } = useMediaLibraryUserPreferences();
  const { onSetSearchTerm, searchTerm } = useMediaLibrarySearchQuery();

  const onQuery = useCallback(
    (text?: string) => {
      onSetSearchTerm(text);
      if (text === '') onSort(preferredSortKey, SortOrder.ASC);
      else onSort(DEFAULT_SORT_KEY, SortOrder.ASC);
    },
    [onSetSearchTerm, onSort, preferredSortKey],
  );

  return (
    <Header>
      <TabFilterBar
        tabFilter={tabFilter}
        onSetSelectedTabFilterId={onSetSelectedTabFilterId}
        selectedTabFilterId={selectedTabFilterId}
      />
      <SearchBar defaultValue={searchTerm} onQuery={onQuery} />
      <FilterBar
        filterList={filterList}
        activeFilterIds={activeFilterIds}
        selectedFilterValueIds={selectedFilterValueIds}
        onChangeSelectedFilterValueIds={onSetSelectedFilterValueIds}
        onChangeActiveFilterIds={onSetActiveFilterIds}
      />
      <TagBar
        filterList={filterList}
        selectedFilterValueIds={selectedFilterValueIds}
        onChangeSelectedFilterValueIds={onSetSelectedFilterValueIds}
      />
    </Header>
  );
}
